import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import { Translate } from '../../localization';

function MenuBar(props) {
    const { hideMenuBar, showMobileSidebar, showSignUpForm, showLoginForm, isLoggedIn } = props;

    return (
        <Dialog className={`mob-sidebar-wrap ${showMobileSidebar ? 'active' : ''}`} open={showMobileSidebar} onClose={hideMenuBar}>
            <div className="mob-sidebar-content">
                <DialogTitle className="sidebar-head">
                    <a href="javascript:void(0);" className="sidebar-logo">
                        <img src="/images/sports/logo.png" />
                    </a>
                    <div className="sidebar-close" onClick={hideMenuBar}>
                        {/* <i className="fa fa-times"></i> */}
                        <img src="/images/mob-close.png" />
                    </div>
                </DialogTitle>
                <DialogContent className="sidebar-content-wrap">
                    {isLoggedIn ? null : (
                        <div className='sidebar-welcome-card'>
                            <h4> Welcome to jackpotCT!</h4>
                            <p>9.3 Average rating from casino players worldwide</p>
                            <div className="welcome-btn-wrap">
                                <button className='btn btn-secondary mr-3 btn-sign-up' onClick={showLoginForm}> {Translate.login}</button>
                                <button className='btn btn-primary btn-login' onClick={showSignUpForm}> {Translate.signup}</button>
                            </div>
                        </div>
                    )}
                    <div className="sidebar-listing-wrap">
                        <ul>
                            <li>
                                <Link to={`/${Translate.getLanguage()}/d/casino`}>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/cherry.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4> {Translate.casino}</h4>
                                            {/* <p>3,000+ Amazing slots to enjoy non-stop</p> */}
                                        </div>
                                    </a>
                                </Link>
                            </li>
                            <li>
                                <Link to={`/${Translate.getLanguage()}/d/live-casino`}>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/dice.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.liveCasino}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li>
                            {/* <li>
                                <Link to='/d/sports'>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/balls-sports.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.sports}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li>
                            <li>
                                <Link to='/d/live'>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/live-streaming.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.live}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li> */}
                            <li>
                                <Link to={`/${Translate.getLanguage()}/d/promotion`}>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/discount.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.promotion}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li>
                            {/* <li>
                                <Link to='/d/loyalty'>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/sidebar-heart.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.loyalty}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li> */}
                            {/* <li>
                                <Link to='/d/hall-of-fame'>
                                    <a className="d-flex align-items-center">
                                        <div className="list-icon">
                                            <img src="/images/sidebar-trophy.png" />
                                        </div>
                                        <div className="list-text">
                                            <h4>{Translate.winners}</h4>
                                        </div>
                                    </a>
                                </Link>
                            </li> */}
                        </ul>
                    </div>
                    {/* <div className="sidebar-listing-wrap">
                    <ul>
                        <li>
                            <a href="javascript:void(0);" className="d-flex align-items-center">
                                <div className="list-icon">
                                    <img src="/images/sidebar-logout.png" />
                                </div>
                                <div className="list-text">
                                    <h4>Logout</h4>                                    
                                </div>
                            </a>
                        </li>
                    </ul>
                </div> */}
                </DialogContent>
            </div>
        </Dialog>
    );
}

export default MenuBar;